<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Impressão de Pedido",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Impressão de Pedido",
      items: [
        {
          text: "Pedidos",
          href: "/pedidos/list"
        },
        {
          text: "Impressão de Pedido",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Pedido #12345</h4>
              <div class="mb-4">
                <img
                    src="@/assets/images/logo-dark.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Cliente:</strong>
                  <br />Cliente Testes 0090 <br />Vitória <br />ES
                  <br />Rua testes, Sem número
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>Entrega:</strong>
                  <br />Rua Testes <br />1234 Centro <br />Vitória
                  <br />00000-000
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Condição:</strong>
                  <br />30 / 60 / 90 dias<br />Boleto
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Data:</strong>
                  <br />04 Abril, 2023
                  <br />
                  <br />
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Produtos</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th style="width: 70px">Código</th>
                  <th>Descrição</th>
                  <th class="text-sm-end">Quantidade</th>
                  <th class="text-sm-end">Valor</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>01</td>
                  <td>Produto Testes 001</td>
                  <td class="text-sm-end">1</td>
                  <td class="text-sm-end">499,00</td>
                </tr>

                <tr>
                  <td>02</td>
                  <td>Produto Testes 0099</td>
                  <td class="text-sm-end">1</td>
                  <td class="text-sm-end">399,00</td>
                </tr>

                <tr>
                  <td>04</td>
                  <td>Produto Testes 000977</td>
                  <td class="text-sm-end">1</td>
                  <td class="text-sm-end">499,00</td>
                </tr>
                <tr>
                  <td colspan="2" class="text-sm-end">Sub Total</td>
                  <td class="text-sm-end">1</td>
                  <td class="text-sm-end">R$ 1.397,00</td>
                </tr>
                <tr>
                  <td colspan="2" class="border-0 text-sm-end">
                    <strong>Frete</strong>
                  </td>
                  <td class="border-0 text-sm-end"></td>
                  <td class="border-0 text-sm-end">R$ 133,00</td>
                </tr>
                <tr>
                  <td colspan="2" class="border-0 text-sm-end">
                    <strong>Total</strong>
                  </td>
                  <td class="border-0 text-sm-end">
                    <h4 class="m-0 text-sm-end"></h4>
                  </td>
                  <td class="border-0 text-sm-end">
                    <h4 class="m-0 text-sm-end">R$ 1.410,00</h4>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                    href="javascript:window.print()"
                    class="btn btn-success waves-effect waves-light me-1"
                ><i class="fa fa-print"></i
                ></a>
                <a
                    href="#"
                    class="btn btn-primary w-md waves-effect waves-light"
                >Compartilhar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
